const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  language: state => state.app.language,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  curTabList:state => state.app.curTabList,
  // username: state => state.user.username,
  roles: state => state.user.roles,
  menus: state => state.user.menus,
  // permissions: state => state.user.permissions,
  routers: state => state.user.routers,
  addRouters: state => state.user.addRouters,
}
export default getters
